import React from "react";

import { classNames } from "../../../helpers/classNames";
import useFetch from "../../../hooks/useFetch";
import { dashboardCount } from "../../../services/dashboardService";
import { formatNumber } from "../../../helpers";

const DashboardCount = () => {
  const { data, error, isLoading, isFetching, refetch, updateData } = useFetch({
    dependencies: ["dashboard-count"],
    fetchFunction: async () => {
      return dashboardCount();
    },
  });

  const countData = [
    {
      title: "Total Admins",
      count: data?.data?.adminCount || 0,
      // bgClass: "bg-[#fb9d42]",
      bgClass: "from-sky-300 to-indigo-300",
    },
    {
      title: "Total Users",
      count: data?.data?.userCount || 0,
      // bgClass: "bg-[#4361ee]",
      bgClass: "from-blue-300 to-purple-300",
    },

    {
      title: "Total Plans",
      count: data?.data?.planCount || 0,
      // bgClass: "bg-[#04d4a3]",
      bgClass: "from-cyan-300 to-blue-400",
    },
    {
      title: "Total Delivered Orders",
      count: data?.data?.orderCount?.delivered?.count || 0,
      // bgClass: "bg-[#ffd166]",
      // bgClass: "from-green-300 to-teal-300",
      bgClass: "from-cyan-300 to-blue-400",
    },
    // {
    //   title: "Total Testimonials",
    //   count: data?.data?.testimonialCount || 0,
    //   // bgClass: "bg-[#ef476f]",
    //   bgClass: "from-pink-300 to-rose-300",
    // },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-4">
      {countData?.map((item, i) => (
        <div
          key={i?.toString()}
          className={classNames(
            "w-full aspect-[3/2] rounded-2xl h-full flex flex-col items-center justify-center py-4 px-4 space-y-4",
            "bg-white/30 backdrop-blur-md border border-white/20 shadow-xl",

            "transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-2xl",

            "animate-fade-in-up",

            item?.bgClass ? `bg-gradient-to-br ${item.bgClass}` : ""
            // item?.bgClass
          )}
          style={item?.bg && { background: item?.bg }}
        >
          <div className="text-5xl font-bold text-center text-cyan-900 drop-shadow-sm font-Poppins">
            {item?.count}
          </div>
          <div className="text-xl font-bold text-center text-cyan-800 drop-shadow-sm font-Poppins">
            {item?.title}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardCount;
